RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    function trimPrimaryDomain(url) {
        // NOTE we want to strip protocol, www subdomain
        return url.replace(/http(s)?:\/\/(www.)?/, '');
    }

    widgets.SharedDomainSubordinateCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'shared-domain-cell text-overflow',
        template: '#socialPostsSharedDomainSubordinateCellTemplate',
        serializeData: function () {
            const me = this;
            const data = me.getOption('data');
            const canonicalUrl = data[1];
            const name = me.getNameFromUrl(canonicalUrl);

            return {
                name: name
            };
        },
        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        },
        getNameFromUrl: function (url) {
            const me = this;

            const freeDimensions = me.model.getFreeDimensions();
            if (!_.includes(freeDimensions, 'primaryDomain')) {
                return trimPrimaryDomain(url);
            }

            const anchor = document.createElement('a');
            anchor.href = url;
            return url.replace(anchor.origin, '');
        }
    });

    const SharedDomainCell = widgets.SharedDomainCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'shared-domain-cell text-overflow',
        template: '#socialPostsSharedDomainCellTemplate',
        serializeData: function () {
            const me = this;
            const data = me.getOption('data');
            const canonicalUrl = data[1];
            const name = me.getNameFromUrl(canonicalUrl);
            const title = me.getTitle(data);

            return {
                name: name,
                url: canonicalUrl,
                title: title
            };
        },
        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        },
        getNameFromUrl: function (url) {
            const me = this;

            const freeDimensions = me.model.getFreeDimensions();
            if (!_.includes(freeDimensions, 'primaryDomain')) {
                return trimPrimaryDomain(url);
            }

            const anchor = document.createElement('a');
            anchor.href = url;
            return url.replace(anchor.origin, '');
        },
        getTitle: function (data) {
            const me = this;

            const metric = _.extend(me.model.build({
                dimensions: ['canonicalUrl'],
                property: 'title'
            }), {
                data: me.model.data
            });

            _.reduce(metric.getFreeDimensions(), function (memo, freeDimension, i) {
                return _.set(memo, freeDimension, data[i]);
            }, metric.attributes);

            return metric.getValue();
        }
    });

    function getMetricDimensionMax(metric, tieBreakerProperty) {
        const values = metric.getValue({
            format: false
        });
        const ordered = _.orderBy(values, _.last, 'desc');
        const max = _.head(ordered);

        if (!max) {
            return;
        }

        const attributes = {};
        attributes[_.head(metric.getFreeDimensions())] = _.head(max);
        const maxMetric = metric.build(attributes);
        maxMetric.data = metric.data;

        if (tieBreakerProperty) {
            const ties = _.takeWhile(_.tail(ordered), function (value) {
                return (_.last(value) === _.last(max));
            });

            const tieMetrics = _.map(ties, function (values) {
                const config = {};
                config[_.head(metric.getFreeDimensions())] = _.head(values);
                const tieMetric = metric.build(config);
                config.data = metric.data;
                return tieMetric;
            });

            return _.reduce(tieMetrics, function (memo, tieMetric) {
                const maxTieBreakerMetric = memo.build({
                    property: tieBreakerProperty
                });
                maxTieBreakerMetric.data = metric.data;
                const maxTieBreakerValue = maxTieBreakerMetric.getValue({
                    format: false
                });

                const tieBreakerMetric = tieMetric.build({
                    property: tieBreakerProperty
                });
                tieBreakerMetric.data = metric.data;
                const tieBreakerValue = tieBreakerMetric.getValue({
                    format: false
                });

                return (tieBreakerValue > maxTieBreakerValue ? tieMetric : memo);
            }, maxMetric);
        }

        return maxMetric;
    }

    function getTopDomainMetric(ctx) {
        const metric = ctx.build({
            property: 'companies_using',
            dimensions: ['primaryDomain'],
            value: undefined
        });
        metric.data = ctx.data;
        return getMetricDimensionMax(metric, 'shared_url_count_distinct');
    }

    const SharedDomains = Dashboard.widgets.SummarizedTableWidget.mixin({
        mixins: {
            linksTableWidgetCsv: App.mixins.LinksTableWidgetCsv
        },
        expansionTracking: RivalIQ.tracking.metric.SocialPostsExpandedTableRow,
        view: App.views.BaseSummarizedTableWidget.extend({
            widgetClassName: 'shared-domain-usage-table',
            sortAttrPrefix: 'primaryDomain',
            dimensionViewMoreMetricProperty: 'shared_url_count_distinct',
            dimensionViewMoreLinkName: 'View URLs'
        }),
        footerView: Dashboard.views.PanelFooter.extend({
            template: '#socialPostsSharedDomainFooterTemplate',
            className: 'panel-footer'
        }),
        hasFooter: _.constant(true),

        title: RivalIQ.strings.social_post_shared_domains_title,
        description: RivalIQ.strings.social_post_shared_domains_description,
        viewMorePath: function (overrides) {
            const me = this;
            const props = _.defaults(overrides || {}, {
                limit: -1,
                instanceId: 'shared-domains'
            }, _.pick(me.getProps(), App.utils.validCurationOptions));
            const route = Dashboard.router.router.resolveCurationRoute(me.curation.id, props);
            return route;
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        },
        getBaseMetric: function () {
            return new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['primaryDomain']
            });
        },
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                dimension: 'canonicalUrl',
                domainsOnly: true,
                showDescriptions: true,
                sortable: true,
                orderBy: [1, 2],
                sortOrder: 1,
                metrics: [
                    {
                        name: 'Domain',
                        property: 'id',
                        orderProperty: 'name'
                    },
                    {
                        property: 'companies_using'
                    },
                    {
                        property: 'shared_url_count_distinct',
                        description: RivalIQ.strings.shared_url_count_domains_distinct_description
                    },
                    {
                        property: 'count',
                        isCompanyUsingPopoverMetric: true,
                        description: RivalIQ.strings.activity_with_urls_domains_description
                    },
                    {
                        property: 'avg_engagement_rate_per_post'
                    }
                ]
            });

            _.extend(props.metrics[0], {
                dimensionView: SharedDomainCell,
                cellView: _.constant(App.views.DomainCell)
            });

            if (!me.metric) {
                me.metric = me.getBaseMetric();
            }

            App.utils.updateMetric(me.metric, props);

            me.metricsCollection = props.metrics;
            RivalIQ.models.MetricDefinition.build(me, me.metric, {}, 'metricsCollection');

            me.summaryMetrics = me.getSummaryMetrics(props);

            return props;
        },
        getSummaryMetrics: function (props) {
            const metric = RivalIQ.metric.build(props, {
                orderBy: undefined,
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['companyId']
            });

            const focusMetric = RivalIQ.metric.build(metric, {
                companyId: props.focusCompanyId
            });

            const landscapeAverageMetric = RivalIQ.metric.build(metric, {
                // NOTE for metrics that define an `aggregate` the `format`
                // property has a special behavior that will cause it to return
                // the export format literal (e.g., `png`) if left in attributes
                format: undefined,
                name: 'Landscape Avg.',
                aggregate: 'average',
                over: ['companyId']
            });

            const metrics = [
                {
                    className: 'col-sm-3',
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Posted Domains',
                            description: RivalIQ.strings.your_shared_domain_count_distinct_description,
                            property: 'shared_domain_count_distinct'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'shared_domain_count_distinct'
                        })
                    ]
                },
                {
                    className: 'col-sm-3',
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Unique URLs / Domain',
                            description: RivalIQ.strings.your_avg_links_per_domain_description,
                            property: 'avg_links_per_domain'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_links_per_domain'
                        })
                    ]
                },
                {
                    title: 'Eng. Rate of Most Commonly Shared Domain',
                    description: RivalIQ.strings.eng_rate_most_commonly_shared_domain_description,
                    className: 'col-sm-6',
                    widgetTypeId: RivalIQ.enums.widgetTypes.METRIC_PROGRESS_BAR,
                    metrics: [
                        {
                            name: function (data, ctx) {
                                const max = getTopDomainMetric(ctx);
                                if (max) {
                                    return max.get(_.head(ctx.getFreeDimensions()));
                                }
                                return 'N/A';
                            },
                            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                            dimensions: ['primaryDomain'],
                            property: 'engagement_total / presence_reach',
                            value: function (options) {
                                const me = this;

                                const max = getTopDomainMetric(me);
                                if (!max) {
                                    return '--%';
                                }

                                const maxEngagementRate = max.build({
                                    property: me.attributes.property
                                });
                                maxEngagementRate.data = me.data;

                                return maxEngagementRate.getValue(options);
                            }
                        },
                        {
                            name: 'Other Domains',
                            concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                            dimensions: ['primaryDomain'],
                            value: function (options) {
                                // This method calculates the engagement_rate for the landscape, excluding the top domain. It does this by:
                                // 1. determining what the top domain is, and what the engagement_total and presence_reach is for that top domain,
                                // 2. getting the engagement_total and presence_reach for the landscape overall, across all domains,
                                // 3. calculating engagement rate as `(landscape_engagement_total - top_domain_engagement_total) / (landscape_presence_reach - top_domain_presence_reach)`

                                const me = this;

                                const topDomain = getTopDomainMetric(me);
                                if (!topDomain) {
                                    return '--';
                                }
                                const topDomainId = topDomain.get('primaryDomain');

                                const landscapeEngagementTotal = me.build({
                                    property: 'engagement_total',
                                    value: undefined,
                                    dimensions: []
                                }, {
                                    clobberDimensions: true
                                });
                                const landscapePresenceReach = me.build({
                                    property: 'presence_reach',
                                    value: undefined,
                                    dimensions: []
                                }, {
                                    clobberDimensions: true
                                });
                                const topDomainEngagementTotal = me.build({
                                    property: 'engagement_total',
                                    primaryDomain: topDomainId,
                                    value: undefined
                                });
                                const topDomainPresenceReach = me.build({
                                    property: 'presence_reach',
                                    primaryDomain: topDomainId,
                                    value: undefined
                                });

                                landscapeEngagementTotal.data = landscapePresenceReach.data = me.data;
                                topDomainEngagementTotal.data = topDomainPresenceReach.data = me.data;

                                const metric = me.build({
                                    property: 'engagement_total / presence_reach',
                                    value: undefined,
                                    dimensions: []
                                }, {
                                    clobberDimensions: true
                                });
                                metric.data = {
                                    engagement_total: landscapeEngagementTotal.getValue({
                                        format: false
                                    }) - topDomainEngagementTotal.getValue({
                                        format: false
                                    }),
                                    presence_reach: landscapePresenceReach.getValue({
                                        format: false
                                    }) - topDomainPresenceReach.getValue({
                                        format: false
                                    })
                                };

                                return metric.getValue(options);
                            }
                        }
                    ]
                }
            ];

            return new Backbone.Collection(metrics);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_SHARED_DOMAIN_TABLE, SharedDomains);

});
